// inviteCodec.js — minimal, dependency-free obfuscator (NOT crypto)

const OPEN_KEY = "houtive-open-key-v0";

// -------- Robust Base64URL utan '=' och utan trim --------
const _b64abc = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
const _b64rev = (() => {
  const m = new Uint16Array(256);
  for (let i = 0; i < _b64abc.length; i++) m[_b64abc.charCodeAt(i)] = i;
  return m;
})();

function b64urlEncode(u8) {
  let out = "";
  let i = 0, l = u8.length;
  while (i + 2 < l) {
    const n = (u8[i++] << 16) | (u8[i++] << 8) | u8[i++];
    out += _b64abc[(n >>> 18) & 63] + _b64abc[(n >>> 12) & 63] +
           _b64abc[(n >>> 6) & 63] + _b64abc[n & 63];
  }
  const rem = l - i;
  if (rem === 1) {
    const n = (u8[i] << 16);
    out += _b64abc[(n >>> 18) & 63] + _b64abc[(n >>> 12) & 63];
    // inga fler tecken, inga '='
  } else if (rem === 2) {
    const n = (u8[i] << 16) | (u8[i + 1] << 8);
    out += _b64abc[(n >>> 18) & 63] + _b64abc[(n >>> 12) & 63] + _b64abc[(n >>> 6) & 63];
  }
  return out.replace(/\+/g, "-").replace(/\//g, "_"); // ingen '=' padding
}

function b64urlDecode(str) {
  if (!str) return new Uint8Array(0);
  const s = str.replace(/-/g, "+").replace(/_/g, "/");
  const len = s.length;
  const rem = len % 4;

  // korrekt utdata-längd utan '='
  const outLen = (Math.floor(len / 4) * 3) + (rem === 2 ? 1 : rem === 3 ? 2 : 0);
  const out = new Uint8Array(outLen);

  let oi = 0, i = 0;
  const full = len - rem;

  while (i < full) {
    const n = (_b64rev[s.charCodeAt(i++)] << 18) |
              (_b64rev[s.charCodeAt(i++)] << 12) |
              (_b64rev[s.charCodeAt(i++)] << 6)  |
               _b64rev[s.charCodeAt(i++)];
    out[oi++] = (n >>> 16) & 255;
    out[oi++] = (n >>> 8) & 255;
    out[oi++] = n & 255;
  }

  if (rem === 2) {
    const n = (_b64rev[s.charCodeAt(i++)] << 18) |
              (_b64rev[s.charCodeAt(i++)] << 12);
    out[oi++] = (n >>> 16) & 255;
  } else if (rem === 3) {
    const n = (_b64rev[s.charCodeAt(i++)] << 18) |
              (_b64rev[s.charCodeAt(i++)] << 12) |
              (_b64rev[s.charCodeAt(i++)] << 6);
    out[oi++] = (n >>> 16) & 255;
    out[oi++] = (n >>> 8) & 255;
  }

  return out;
}

// -------- FNV-1a 32-bit (key->seed) --------
function fnv1a32(s) {
  let h = 0x811c9dc5 >>> 0;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

// -------- Keystream per byte (xorshift32) --------
function keystreamBytes(seed, n) {
  let x = (seed >>> 0) || 0x9e3779b9;
  const out = new Uint8Array(n);
  for (let i = 0; i < n; i++) {
    x ^= (x << 13) >>> 0;
    x ^= (x >>> 17) >>> 0;
    x ^= (x << 5) >>> 0;
    out[i] = x & 0xff;
  }
  return out;
}

// -------- ASCII helpers --------
function strToUint8(s) {
  const u = new Uint8Array(s.length);
  for (let i = 0; i < s.length; i++) u[i] = s.charCodeAt(i) & 0xff;
  return u;
}
function uint8ToStr(u) {
  let s = "";
  for (let i = 0; i < u.length; i++) s += String.fromCharCode(u[i]);
  return s;
}

// -------- Normalisera: '+4670...' => '070...' --------
function normalizePhone(inPhone) {
  if (!inPhone) return "";
  const digitsPlus = String(inPhone).replace(/[^\d+]/g, "");
  let s = digitsPlus;
  if (s.startsWith("+")) s = s.slice(1);
  if (s.startsWith("00")) s = s.slice(2);
  if (s.startsWith("46")) s = "0" + s.slice(2);
  if (s.startsWith("0")) return s;
  return s;
}

// -------- Publikt API --------
export function encodeInvite(phone, key) {
  const local = normalizePhone(phone);             // "070..."
  const seed = fnv1a32((key || OPEN_KEY) + "");    // sträng-seed
  const pt = strToUint8(local);
  const ks = keystreamBytes(seed, pt.length);
  const ct = new Uint8Array(pt.length);
  for (let i = 0; i < pt.length; i++) ct[i] = pt[i] ^ ks[i];
  return b64urlEncode(ct);                         // 10 bytes -> 14 tecken
}

// export function decodeInvite(token, key) {
//   if (!token) return null;
//   const ct = b64urlDecode(token);
//   if (!ct || ct.length === 0) return null;
//   const seed = fnv1a32((key || OPEN_KEY) + "");
//   const ks = keystreamBytes(seed, ct.length);
//   const pt = new Uint8Array(ct.length);
//   for (let i = 0; i < ct.length; i++) pt[i] = ct[i] ^ ks[i];
//   const s = uint8ToStr(pt);
//   return /^0\d{6,}$/.test(s) ? { s} : null;
// }

export function decodeInvite(token, key) {
  try {
    // Om det saknas en obfuskerat telenr är det okej
    if (!token) return { ok: true, value: null, error: 'missing_token' };

    const ct = b64urlDecode(token);
    if (!ct || ct.length === 0) return { ok: false, value: null, error: 'decode_failed' };

    const seed = fnv1a32(String(key ?? OPEN_KEY));
    const ks = keystreamBytes(seed, ct.length);
    const pt = new Uint8Array(ct.length);
    for (let i = 0; i < ct.length; i++) pt[i] = ct[i] ^ ks[i];

    const s = uint8ToStr(pt);
    if (/^0\d{6,}$/.test(s)) return { ok: true, value: s };

    return { ok: false, value: null, error: 'pattern_mismatch' };
  } catch (e) {
    return { ok: false, value: null, error: e instanceof Error ? e.message : String(e) };
  }
}


// --- debug helper för felsökning ---
export function debugEncode(phone, key) {
  const local = normalizePhone(phone);
  const seed = fnv1a32((key || OPEN_KEY) + "");
  const pt = strToUint8(local);
  const ks = keystreamBytes(seed, pt.length);
  const ct = new Uint8Array(pt.length);
  for (let i = 0; i < pt.length; i++) ct[i] = pt[i] ^ ks[i];
  const token = b64urlEncode(ct);
  return { local, seed, pt: Array.from(pt), ks: Array.from(ks), ct: Array.from(ct), token, tokenLen: token.length };
}